<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h4 style="float: left;">All Branches : </h4>
                <div style="clear: both;margin-bottom: 5px;"></div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-12">
                            <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-3 col-12">
                            <select [(ngModel)]='rootSearchType' class="form-control mb-2" style="height: 32px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                          <option disabled>Searching By Branch Type</option>
                          <option>All</option>
                          <option *ngFor='let x of typeofrootA' [value]="x.id">{{x.name}}</option>
                  </select>
                        </div>
                        <div class="col-lg-3 col-12" *ngIf='add'>
                            <button (click)='addRoot()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height:0; " type="button" class="btn btn-secondary mb-2">Add Branch</button>
                        </div>
                    </div>
                </div>
            </div>



            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style='text-align: center;'>No.</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Branch_Type</th>
                                    <!-- <th scope="col">Phone</th> -->
                                    <th scope="col">Location</th>
                                    <!-- <th scope="col">City</th> -->
                                    <!-- <th scope="col">Notes</th> -->
                                    <th scope="col" *ngIf='update'>Update</th>
                                    <th scope="col" *ngIf='delete'>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of rootA|searchName:searchName|rootSearchType:rootSearchType; let n = index;'>
                                    <th scope="row" style='text-align: center;'>{{n+1}}</th>
                                    <td data-title="Name">{{v.name}}</td>
                                    <td data-title="Code">{{v.id}}</td>
                                    <td data-title="Branch_Type">{{v.typeofrootname}}</td>
                                    <!-- <td data-title="Phone" >0{{v.phone}}</td> -->
                                    <td data-title="Location">{{v.location}}</td>
                                    <!-- <td data-title="City" >{{v.city}}</td> -->
                                    <!-- <td data-title="Notes" >{{v.notes}}</td> -->
                                    <td data-title="Update" *ngIf='update'><button (click)='upR(v)' type="button" class="btn btn-success" style="box-shadow: none;"><i class="fas fa-edit"></i></button></td>
                                    <td data-title="Delete" *ngIf='delete'><button (click)='delR(v.id)' type="button" class="btn btn-danger" style="box-shadow: none;"><i class="fas fa-trash-alt"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

















        </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addRoot0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
                          <label style="color: white;">Name : </label>
              <input style="height: 25px;"  class="text mt-2 d1" type="text" name="name" [(ngModel)]='name' placeholder="Name" required="">
              <!-- <input  class="text mt-2 d1" type="text" name="notes" [(ngModel)]='notes' placeholder="Add Notes" required=""> -->
              <label style="color: white;" class="mt-2">Location : </label>
              <input style="height: 25px;"  class="text mt-2 d1" type="text" name="location" [(ngModel)]='location' placeholder="Location" required="">
              <label style="color: white;" class="mt-2">City : </label>
              <input style="height: 25px;"  class="text mt-2 d1" type="text" name="city" [(ngModel)]='city' placeholder="City" required="">
              <label style="color: white;" class="mt-2">Phone : </label>
              <input style="height: 25px;"  class="text mt-2 d1" type="number" name="phone" [(ngModel)]='phone' placeholder="Phone" required="">
              <label style="color: white;" class="mt-2">Branch Type : </label>
<select [(ngModel)]='typeofroot' name="typeofroot" class="form-control mt-4 select2 typerootselect" style="height: unset !important;">
<option [value]='typeofroot' disabled>Branch Type</option>
<option *ngFor='let r of typeofrootA' [value]="r.id">{{r.name}}</option>
</select>
                <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add">
                <div style="clear: both;"></div>
                </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
            <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Delete confirmation">
            <div style="clear: both;"></div>
            </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data='ngForm' (submit)='okUp(data.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                  <input style="height: 25px;"  class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
                  <!-- <input  class="text mt-2 d1" type="text" name="notesU" [(ngModel)]='notesU' placeholder="Notes" required=""> -->
                  <input style="height: 25px;"  class="text mt-2 d1" type="text" name="locationU" [(ngModel)]='locationU' placeholder="Location" required="">
              <input style="height: 25px;"  class="text mt-2 d1" type="text" name="cityU" [(ngModel)]='cityU' placeholder="City" required="">
              <input style="height: 25px;"  class="text mt-2 d1 mb-2" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
        <select [(ngModel)]='typeofrootU' name="typeofrootU" class="form-control mt-4 select2 typeofrootUselect" style="height: unset !important;">
          <option [value]='typeofrootU' disabled>Branch</option>
          <option *ngFor='let x of typeofrootA' [value]="x.id">{{x.name}}</option>
  </select>
                    <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Update">
                    <div style="clear: both;"></div>
              </span>
                </form>
            </div>
        </div>
    </div>
</section>